import React, { Component } from "react";
import "./index.scss";
import { GetBusinessTemplateCategory } from '@/utils/Global'
import i18n from '@/i18n'
import { Trans } from 'react-i18next'

class DynamicSection extends Component {
    render() {
		const BUSINESS_TEMPLATE_CATEGORY = GetBusinessTemplateCategory()
        return (
            <div className="dynamic-section-root-container">
                <div className="heading">
					<Trans
                        i18nKey="web.newhome.dynamic.title"
                        components={[
                            <br />,
                            <span />,
                        ]}
                    />
                </div>
                <div className="subtitle"><img className="premium" src="https://front.videomonster.com/images-7cuytg20/web/premium.svg" alt="" />Dynamic Shorts</div>
                <div className="video-area">
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/dynamic/63774bfd723f1131b1350dd0.mp4"
                        autoPlay
                        loop
                        muted
                    />
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/dynamic/63369958f2216e34b108c73a.mp4"
                        autoPlay
                        loop
                        muted
                    />
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/dynamic/632413b02a60a3003454d68e.mp4"
                        autoPlay
                        loop
                        muted
                    />
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/dynamic/632414182a60a3003454d6a6.mp4"
                        autoPlay
                        loop
                        muted
                    />
                </div>
				<div
                    className="setting-btn"
                    onClick={() =>
                        this.props.history.push({
                            pathname: "/designselect",
                            state: {
                                businessCategory:
                                    BUSINESS_TEMPLATE_CATEGORY
                                        .DynamicShorts.key,
                            },
                        })
                    }
                >
                   {i18n.t("web.newhome.dynamic.button")}
                </div>
            </div>
        );
    }
}

export default DynamicSection;
